/** Riepilogo di un blocco del wizard: cosa ha detto, in chiaro, con la possibilita di cambiarlo. */
export type SummaryItem = {
  label: string
  /** Assente = domanda saltata: si dice in parole, non con uno spazio vuoto. */
  value?: string
}

export type SummarySectionProps = {
  title: string
  items: readonly SummaryItem[]
  editLabel?: string
  onEdit?: () => void
}

export function SummarySection({ title, items, editLabel = 'Modifica', onEdit }: SummarySectionProps) {
  return (
    <section className="rounded-card border-2 border-line bg-surface px-[22px] py-[20px]">
      <h2 className="text-band font-bold text-ink">{title}</h2>
      <dl className="mt-2">
        {items.map((item) => (
          <div key={item.label} className="border-b-2 border-line py-3 last:border-b-0">
            <dt className="text-soft text-meta text-ink">{item.label}</dt>
            <dd className="text-body text-ink">{item.value ?? 'Non ancora risposto'}</dd>
          </div>
        ))}
      </dl>
      {onEdit && (
        <button
          type="button"
          onClick={onEdit}
          className="mt-2 min-h-touch px-1 text-meta text-ink underline underline-offset-4"
        >
          {editLabel}
        </button>
      )}
    </section>
  )
}
